const AMENITIES_LOCALE = {
  'en-gb': {
    filter_10: 'Poolside bar',
    filter_9: 'Restaurant',
    filter_8: 'Smoke-free property',
    filter_7: 'Smoking area',
    filter_6: 'Airport transfer',
    filter_5: 'Private beach',
    filter_4: 'Spa',
    filter_3: 'Gym',
    filter_2: 'Pool',
    filter_1: 'Free Wifi',
    filter_14: 'Sauna',
    filter_13: 'Tennis court',
    filter_seeless: 'See less',
    filter_15: 'Nightclub',
    filter_12: 'Bar',
    filter_seemore: 'See more',
    filter_11: 'Cafe',
  },
  'id-id': {
    filter_10: 'Bar kolam renang',
    filter_9: 'Restoran',
    filter_8: 'Properti bebas rokok',
    filter_7: 'Area merokok',
    filter_6: 'Transfer bandara',
    filter_5: 'Pantai pribadi',
    filter_4: 'Spa',
    filter_3: 'Gym',
    filter_2: 'Kolam renang',
    filter_1: 'Wifi Gratis',
    filter_14: 'Sauna',
    filter_13: 'Lapangan tenis',
    filter_seeless: 'Pendekkan',
    filter_15: 'Klub malam',
    filter_12: 'Bar',
    filter_seemore: 'Lainnya',
    filter_11: 'Kafe',
  },
  'ja-jp': {
    filter_10: 'プールサイドバー',
    filter_9: 'レストラン',
    filter_8: '全館禁煙',
    filter_7: '喫煙エリア',
    filter_6: '空港送迎',
    filter_5: 'プライベートビーチ',
    filter_4: 'スパ',
    filter_3: 'ジム',
    filter_2: 'プール',
    filter_1: '無料WiFi',
    filter_14: 'サウナ',
    filter_13: 'テニスコート',
    filter_seeless: '一部のみ表示',
    filter_15: 'ナイトクラブ',
    filter_12: 'バー',
    filter_seemore: 'もっと見る',
    filter_11: 'カフェ',
  },
  'ko-kr': {
    filter_10: '풀사이드 바',
    filter_9: '레스토랑',
    filter_8: '금연 시설',
    filter_7: '흡연 구역',
    filter_6: '공항 교통편',
    filter_5: '프라이빗 비치',
    filter_4: '온천',
    filter_3: '헬스장',
    filter_2: '풀',
    filter_1: '무료 와이파이',
    filter_14: '찜질방',
    filter_13: '테니스 코트',
    filter_seeless: '접기',
    filter_15: '나이트 클럽',
    filter_12: '바',
    filter_seemore: '더 보기',
    filter_11: '카페',
  },
  'ms-my': {
    filter_10: 'Bar tepi kolam',
    filter_9: 'Restoran',
    filter_8: 'Penginapan bebas asap rokok',
    filter_7: 'Kawasan merokok',
    filter_6: 'Perkhidmatan pengangkutan lapangan terbang',
    filter_5: 'Pantai peribadi',
    filter_4: 'Spa',
    filter_3: 'Gimnasium',
    filter_2: 'Kolam renang',
    filter_1: 'Wi-Fi Percuma',
    filter_14: 'Sauna',
    filter_13: 'Gelanggang tenis',
    filter_seeless: 'Sembunyikan',
    filter_15: 'Kelab malam',
    filter_12: 'Bar',
    filter_seemore: 'Lihat lagi',
    filter_11: 'Kafe',
  },
  'th-th': {
    filter_10: 'บาร์ริมสระน้ํา',
    filter_9: 'ร้านอาหาร',
    filter_8: 'ที่พักปลอดบุหรี่',
    filter_7: 'พื้นที่สูบบุหรี่',
    filter_6: 'บริการรับ-ส่งสนามบิน',
    filter_5: 'ชายหาดส่วนตัว',
    filter_4: 'สปา',
    filter_3: 'ยิมออกกำลังกาย',
    filter_2: 'สระว่ายน้ำ',
    filter_1: 'Wi-Fi ฟรี',
    filter_14: 'ซาวน่า',
    filter_13: 'สนามเทนนิส',
    filter_seeless: 'ดูน้อยลง',
    filter_15: 'ไนต์คลับ',
    filter_12: 'บาร์',
    filter_seemore: 'ดูเพิ่มเติม',
    filter_11: 'คาเฟ่',
  },
  'vi-vn': {
    filter_10: 'Quầy bar bên bể bơi',
    filter_9: 'Nhà hàng',
    filter_8: 'Khách sạn không hút thuốc',
    filter_7: 'Khu vực hút thuốc',
    filter_6: 'Đưa đón từ sân bay',
    filter_5: 'Bãi biển riêng',
    filter_4: 'Spa',
    filter_3: 'Phòng tập thể hình',
    filter_2: 'Bể bơi',
    filter_1: 'Wifi miễn phí',
    filter_14: 'Tắm hơi',
    filter_13: 'Sân quần vợt',
    filter_seeless: 'Xem ít hơn',
    filter_15: 'Hộp đêm',
    filter_12: 'Quầy bar',
    filter_seemore: 'Xem thêm',
    filter_11: 'Quán cafe',
  },
  'zh-cn': {
    filter_10: '泳池酒吧',
    filter_9: '餐厅',
    filter_8: '无烟酒店',
    filter_7: '吸烟区',
    filter_6: '机场中转',
    filter_5: '私人海滩',
    filter_4: '水疗',
    filter_3: '健身房',
    filter_2: '游泳池',
    filter_1: '免费Wi-Fi',
    filter_14: '桑拿',
    filter_13: '网球场',
    filter_seeless: '显示更少',
    filter_15: '夜店',
    filter_12: '酒吧',
    filter_seemore: '查看更多',
    filter_11: '小餐馆',
  },
  'zh-hk': {
    filter_10: '池邊酒吧',
    filter_9: '餐廳',
    filter_8: '本場地禁煙',
    filter_7: '吸煙區',
    filter_6: '機場接送',
    filter_5: '私人海灘',
    filter_4: 'Spa水療',
    filter_3: '健身房',
    filter_2: '游泳池',
    filter_1: '免費WIFI',
    filter_14: '桑拿',
    filter_13: '網球場',
    filter_seeless: '縮回',
    filter_15: '夜總會',
    filter_12: '酒吧',
    filter_seemore: '查看更多',
    filter_11: '咖啡廳',
  },
  'zh-tw': {
    filter_10: '池畔酒吧',
    filter_9: '餐廳',
    filter_8: '無菸場所',
    filter_7: '吸菸區',
    filter_6: '機場接送',
    filter_5: '私人海灘',
    filter_4: '水療',
    filter_3: '健身房',
    filter_2: '游泳池',
    filter_1: '免費WiFi',
    filter_14: '桑拿',
    filter_13: '網球場',
    filter_seeless: '顯示較少',
    filter_15: '夜店',
    filter_12: '酒吧',
    filter_seemore: '查看更多',
    filter_11: '咖啡廳',
  },
};

export default AMENITIES_LOCALE;
